import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import { getReactRecoilSettings } from '../../settings.js';
const productListState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productList',
    service: Core.SearchProducts,
    beforeRequest: ({ req }) => {
        const settings = getReactRecoilSettings();
        const defaultRequest = {
            PageSize: settings.defaultPageSize,
            IncludedFields: settings.defaultProductProperties,
        };
        const newRequest = {
            ...defaultRequest,
            ...req,
        };
        return newRequest;
    },
});
export default productListState;
//# sourceMappingURL=product-list-state.js.map